/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Undefined
 *
 * 1 = Female
 *
 * 2 = Male
 */
export enum UserGender {
  Undefined = 0,
  Female = 1,
  Male = 2,
}
